// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en'

Vue.use(ElementUI, {locale});

import storage from './fetch/storage';
Vue.prototype.$storage = storage;

import token from './fetch/accessToken';
Vue.prototype.$token = token;

import api from './fetch/api';
Vue.prototype.$api = api;

import tool from './fetch/tool';
Vue.prototype.$tool = tool;

import config from './fetch/config';
Vue.prototype.$config = config;

import Icon from './components/common/icon';
Vue.component('icon', Icon);

import Screen from './components/common/screen';
Vue.component('screen', Screen);

import PendingPopup from  './components/common/pendingPopup';
Vue.component('pending-popup',PendingPopup);

Vue.config.productionTip = false;

Vue.prototype.$passReg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[1-9])(?=.*[\W]).{6,}$/;

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth && !token.getAccessToken()) {
    // storage.set('history_url', to.fullPath);
    next({
      path: '/login'
    })
  } else {
    next();
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

 function getQueryVariable(variable) {
       console.log('aaaa')
      }

 window.gotoPage = getQueryVariable


// WEBPACK FOOTER //
// ./src/main.js